import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { bindRtkActionToPromise } from 'app/utils/promiseActions';
import { websocketActions } from 'middleware/websocket/actions/websocket';
import { debugLog } from 'utils/debugLog';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
/** A component that displays a modal when the network connection is lost. */
export const NetworkConnectionLostModal = createAppModal({ type: 'app:networkConnectionLost' }, ({ isOpen, hide }) => {
    const dispatch = useAppDispatch();
    const webSocketCreateAsyncStatus = useAppSelector((state) => state.websocket.meta.asyncCreateStatus);
    /** Handles the modal confirm action. */
    const handleConfirm = () => {
        debugLog('NETWORK-CONNECTIVITY', 'User attempting to manually reconnect');
        bindRtkActionToPromise(dispatch, websocketActions.create)()
            .then(hide)
            .catch();
    };
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: hide, allowEscClose: false }, { children: [_jsx(ModalHead, { title: "Connection lost" }), _jsx(ModalBody, { children: "The connection has been lost. Try reconnecting." }), _jsx(ModalFoot, { confirmOnClick: handleConfirm, confirmName: "Reconnect", confirmProps: {
                    isLoading: webSocketCreateAsyncStatus === 'pending',
                    loadingIndicator: 'Reconnecting...',
                } })] })));
});
